import { useI18n } from 'next-localization';
import { useConditionalRendering } from './useConditionalRendering';
import { ArticleFields } from './ArticleBase.types';
import { SocialMediaLink } from './shared.types';
import { SvgIconType } from '@ahc-digital/component-library';
import { usePathname } from 'next/navigation';
import React, { useEffect, useState } from 'react';

export function GetArticleBaseModel(
  props: ArticleFields | undefined,
  socialMediaLinks: SocialMediaLink[]
) {
  const { renderRichText, renderText, renderImage } = useConditionalRendering();
  const { t } = useI18n() || {};
  const pathName = usePathname();
  const [currentPageUrl, setCurrentPageUrl] = useState('');

  useEffect(() => {
    const pageUrl = window.location.href + pathName;
    setCurrentPageUrl(pageUrl);
  }, [pathName]);

  const formattedDate = new Date(props?.PublishDate?.value ?? '').toLocaleDateString('en-US', {
    year: 'numeric',
    month: 'long',
    day: 'numeric',
  });

  return {
    headline: renderText(props?.Headline, { required: true }),
    subHeadline: renderText(props?.Subheadline),
    publishDate: formattedDate,
    mainContent: renderRichText(props?.MainContent),
    image: renderImage(props?.FeaturedImage),
    imageCaption: renderText(props?.FeaturedImageCaption),
    shouldDisplaySocialMediaIcons: props?.DisplayShare?.value,
    socialShareLabel: t('NewsAndBlogs-ShareThisStory'),
    shouldHideSubHeadline: props?.HideSubheadline?.value,
    socialMediaLinks: socialMediaLinks?.map((item) => {
      const socialMediaType = item?.type as SvgIconType;
      const link = item?.link + currentPageUrl;
      const capitalizedSocialMediaType =
        socialMediaType.charAt(0).toUpperCase() + socialMediaType.slice(1);
      return {
        link: (
          <a
            target="_blank"
            href={`${link}`}
            title={`${capitalizedSocialMediaType}`}
            aria-label={`${capitalizedSocialMediaType}`}
          />
        ),
        icon: socialMediaType,
      };
    }),
  };
}
